<template>
    <!--
        Confirm component.
        Displays content inside a layer above the page content.
        Closable only by clicking cancel or okay button or esc key
    -->
    <div :class="['confirm', 'modal', legal ? 'legal' : '']">
        <transition name="fade">
            <div class="modal-background" @click="decline" v-if="show"></div>
        </transition>

        <transition name="bounce-in">
            <div class="modal-content" v-if="show">
                <div class="too-small" v-if="legal">
                    {{ $t('confirm.legal.too_small') }}
                    <action color="blue" @click.native="close">{{ $t('common.button.okay') }}</action>
                </div>

                <div class="head" v-if="headline !== ''">
                    <h2>
                        {{ headline }}
                    </h2>
                </div>

                <div class="legal-body" v-if="legal">
                    <div class="legal-content">
                        <div class="scroll-notice">{{ $t('confirm.legal.scroll_notice') }}</div>
                        <iframe :src="content.iframe + '?' + hash" width="100%" height="100%" scrolling="yes"></iframe>
                    </div>

                    <div class="legal-statement" v-if=" ! content.accepted">
                        <input type="checkbox" value="yes" name="confirmation" id="confirmation" v-model="confirmed">
                        <label for="confirmation">
                        <span v-html="$t('confirm.legal.statement.0', {name: $store.state.current.user.name})"></span>
                        <ul>
                            <li>{{ $t('confirm.legal.statement.1') }}</li>
                            <li v-html="$t('confirm.legal.statement.2', {company: $store.state.current.account.name})"></li>
                            <li>{{ $t('confirm.legal.statement.3') }}</li>
                        </ul>
                        </label>
                    </div>
                </div>

                <template v-else>
                    <div class="body" v-if="html && content" v-html="content"></div>

                    <div class="body" v-if=" ! html && content">
                        {{ content }}
                    </div>
                </template>

                <div class="modal-footer">
                    <action @click.native="print" color="blue" class="left" v-if="legal && content.print">
                        {{ $t('label.print') }}
                    </action>

                    <action @click.native="confirm" color="green" v-if=" ! legal || (legal && ! content.accepted)">
                        {{ labelConfirm }}
                    </action>

                    <action @click.native="decline" color="transparent" v-if=" ! legal || (legal && ! content.accepted)">
                        {{ labelDecline }}
                    </action>

                    <action @click.native="close" v-if="legal && content.accepted">
                        {{ $t('common.button.close') }}
                    </action>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import events from '../../events/events';

export default
{
    name: 'Confirm',

    data() {
        return {
            show: false,
            html: false,
            legal: false,
            hash: null,
            confirmed: false,
            accepted: false,
            headline: '',
            content: '',
            callbackConfirm: null,
            callbackDecline: null,
            labelConfirm: '',
            labelDecline: '',
        }
    },

    created()
    {
        /**
         * Open confirm dialog.
         * Adds event listener to window object for key esc
         *
         * @param {String} headline
         * @param {String} content | {Object} legal
         * @param {Object} callback { confirm: Function, decline: Function }
         * @param {Object} label { confirm: String, decline: String }
         * @param {Object} html (bool)
         */
        events.$on('confirm.open', (headline, content, callback, label, html) =>
        {
            this.headline = headline;
            this.content = content;
            this.callbackConfirm = (callback && callback.confirm !== 'undefined') ? callback.confirm : null;
            this.callbackDecline = (callback && callback.decline !== 'undefined') ? callback.decline : null;
            this.labelConfirm = (label && label.confirm !== 'undefined') ? label.confirm : this.$t('text.yes') ;
            this.labelDecline = (label && label.decline !== 'undefined') ? label.decline : this.$t('text.no') ;

            this.show = true;
            this.confirmed = false;
            this.html = (html) ? true : false;

            // content = {iframe: 'https...', print: 'https...', accepted: true}
            this.legal = (typeof content === 'object') ? true : false;
            this.hash = Date.now(); // cache buster for iframe ?hash

            window.addEventListener('keyup', this.closeEsc, false);
            window.addEventListener('keyup', this.confirmEnter, false);
        });
    },

    methods:
    {
        /**
         * Close dialog and remove event listener from window
         */
        close() {
            window.removeEventListener('keyup', this.closeEsc, false);
            window.removeEventListener('keyup', this.confirmEnter, false);
            this.show = false;

            this.headline = '';
            this.content = '';
            this.labelConfirm = '';
            this.labelDecline = '';
            this.callbackConfirm = null;
            this.callbackDecline = null;
        },

        /**
         * Triggers decline method on escape
         *
         * @param {Object} e
         */
        closeEsc(e) {
            if (e.keyCode === 27) {
                this.decline();
            }
        },

        /**
         * Triggers confirm method on enter
         *
         * @param {Object} e
         */
        confirmEnter(e) {
            if (e.keyCode === 13) {
                this.confirm();
            }
        },

        /**
         * Trigger confirm callback
         */
        confirm()
        {
            if (this.legal && ! this.confirmed)
            {
                alert('Please check the box in order to accept.');
                return;
            }

            if (typeof this.callbackConfirm === 'function')
                this.callbackConfirm();

            this.close();
        },

        /**
         * Trigger decline callback
         */
        decline()
        {
            if (typeof this.callbackDecline === 'function')
                this.callbackDecline();

            this.close();
        },

        /**
         * Trigger print callback
         */
        print()
        {
            window.open(this.content.print);
        },
    }
}
</script>



// WEBPACK FOOTER //
// Confirm.vue?3cf24ad8